import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import isEqual from 'lodash/isEqual';
import { useHistory } from 'react-router';

import { ContextWrapper } from './wrapper.context';
import { userHasChatsAccess } from 'utils/chats';
import { getUnReadChats } from 'services/chats';

import { connectedPlugins } from 'components/connectPlugin/utils/helper';
import { notify } from 'components/Notify/Notify';

export const UnreadCounterContext = createContext({});

export const UnreadCounterProvider = ({ children }) => {
  const { businessInfo } = useContext(ContextWrapper);
  const [globalUnReadCounter, setGlobalUnreadCounter] = useState({
    instagram: 0,
    messenger: 0,
    unreadChats: 0
  });
  const history = useHistory();

  const hasConnectedPlugins = connectedPlugins(businessInfo);
  const intervalId = useRef(null);

  const getUnreadChatsCounter = useCallback(async () => {
    try {
      if (userHasChatsAccess(businessInfo)) {
        const unreadChats = await getUnReadChats();

        setGlobalUnreadCounter((prevCount) => {
          if (!isEqual(prevCount, unreadChats)) {
            return unreadChats;
          }
          return prevCount;
        });
      }
    } catch (error) {
      notify({ msg: error.message, error });
    }
  }, [businessInfo, setGlobalUnreadCounter]);

  useEffect(() => {
    const checkIsConnected = businessInfo?._id && hasConnectedPlugins?.length;

    if (checkIsConnected && history.location.pathname !== '/chats') {
      getUnreadChatsCounter();

      intervalId.current = setInterval(() => {
        getUnreadChatsCounter();
      }, 30000);
    }

    return () => clearInterval(intervalId.current);
  }, [
    businessInfo?._id,
    hasConnectedPlugins?.length,
    getUnreadChatsCounter,
    history.location.pathname
  ]);

  return (
    <UnreadCounterContext.Provider
      value={{
        globalUnReadCounter,
        setGlobalUnreadCounter,
        getUnreadChatsCounter,
        intervalId
      }}
    >
      {children}
    </UnreadCounterContext.Provider>
  );
};
